"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.labRequisitionsMapper = labRequisitionsMapper;
function labRequisitionsMapper(data) {
    console.log("data: ", data);
    return data;
}
